import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';
import { useLanguage } from '../context/LanguageContext';
import { LanguageSelector } from '../components/LanguageSelector';

export default function Terms() {
  const { t, language } = useLanguage();

  const content = {
    pt: {
      intro: 'Bem-vindo ao SharpBetAI. Ao utilizar os nossos serviços, concordas com os seguintes termos.',
      sections: [
        {
          title: '1. Serviço',
          text: 'O SharpBetAI é uma plataforma de análise de apostas desportivas que utiliza inteligência artificial para sugerir combinações de apostas. Não somos uma casa de apostas e não processamos apostas diretamente.'
        },
        {
          title: '2. Elegibilidade',
          text: 'Para utilizar o SharpBetAI, deves ter pelo menos 18 anos de idade (ou a idade legal mínima para apostas na tua jurisdição). Ao criar uma conta, confirmas que cumpres este requisito.'
        },
        {
          title: '3. Sem Garantia de Lucro',
          text: 'As análises e sugestões fornecidas pelo SharpBetAI são baseadas em dados estatísticos e algoritmos de IA. Não garantimos lucros ou resultados positivos. Todas as apostas envolvem risco de perda.'
        },
        {
          title: '4. Responsabilidade do Utilizador',
          text: 'És totalmente responsável pelas tuas decisões de apostas. O SharpBetAI fornece informações para análise, mas a decisão final de apostar é tua. Recomendamos que apostes apenas o que podes perder.'
        },
        {
          title: '5. Conta e Subscrição',
          text: 'Os planos de subscrição (Pro e VIP) são cobrados mensalmente. Podes cancelar a qualquer momento. Após o cancelamento, manterás acesso até ao final do período de faturação atual.'
        },
        {
          title: '6. Dados e Precisão',
          text: 'Esforçamo-nos por fornecer dados precisos e atualizados, mas não garantimos a exatidão de todas as informações. Os dados provêm de fontes terceiras (API-Football) e podem estar sujeitos a atrasos ou erros.'
        },
        {
          title: '7. Uso Aceitável',
          text: 'Não deves utilizar o serviço para fins ilegais ou não autorizados. Reservamo-nos o direito de suspender ou terminar contas que violem estes termos.'
        },
        {
          title: '8. Alterações aos Termos',
          text: 'Podemos atualizar estes termos periodicamente. Notificar-te-emos de quaisquer alterações significativas por email ou através da plataforma.'
        }
      ]
    },
    en: {
      intro: 'Welcome to SharpBetAI. By using our services, you agree to the following terms.',
      sections: [
        {
          title: '1. Service',
          text: 'SharpBetAI is a sports betting analysis platform that uses artificial intelligence to suggest betting combinations. We are not a bookmaker and do not process bets directly.'
        },
        {
          title: '2. Eligibility',
          text: 'To use SharpBetAI, you must be at least 18 years old (or the legal minimum age for betting in your jurisdiction). By creating an account, you confirm that you meet this requirement.'
        },
        {
          title: '3. No Profit Guarantee',
          text: 'The analyses and suggestions provided by SharpBetAI are based on statistical data and AI algorithms. We do not guarantee profits or positive results. All betting involves risk of loss.'
        },
        {
          title: '4. User Responsibility',
          text: 'You are fully responsible for your betting decisions. SharpBetAI provides information for analysis, but the final decision to bet is yours. We recommend only betting what you can afford to lose.'
        },
        {
          title: '5. Account and Subscription',
          text: 'Subscription plans (Pro and VIP) are billed monthly. You can cancel at any time. After cancellation, you will retain access until the end of the current billing period.'
        },
        {
          title: '6. Data and Accuracy',
          text: 'We strive to provide accurate and up-to-date data, but we do not guarantee the accuracy of all information. Data comes from third-party sources (API-Football) and may be subject to delays or errors.'
        },
        {
          title: '7. Acceptable Use',
          text: 'You must not use the service for illegal or unauthorized purposes. We reserve the right to suspend or terminate accounts that violate these terms.'
        },
        {
          title: '8. Changes to Terms',
          text: 'We may update these terms periodically. We will notify you of any significant changes via email or through the platform.'
        }
      ]
    },
    es: {
      intro: 'Bienvenido a SharpBetAI. Al usar nuestros servicios, aceptas los siguientes términos.',
      sections: [
        {
          title: '1. Servicio',
          text: 'SharpBetAI es una plataforma de análisis de apuestas deportivas que utiliza inteligencia artificial para sugerir combinaciones de apuestas. No somos una casa de apuestas y no procesamos apuestas directamente.'
        },
        {
          title: '2. Elegibilidad',
          text: 'Para usar SharpBetAI, debes tener al menos 18 años (o la edad legal mínima para apostar en tu jurisdicción). Al crear una cuenta, confirmas que cumples este requisito.'
        },
        {
          title: '3. Sin Garantía de Beneficios',
          text: 'Los análisis y sugerencias proporcionados por SharpBetAI se basan en datos estadísticos y algoritmos de IA. No garantizamos beneficios ni resultados positivos. Todas las apuestas implican riesgo de pérdida.'
        },
        {
          title: '4. Responsabilidad del Usuario',
          text: 'Eres totalmente responsable de tus decisiones de apuestas. SharpBetAI proporciona información para análisis, pero la decisión final de apostar es tuya.'
        },
        {
          title: '5. Cuenta y Suscripción',
          text: 'Los planes de suscripción (Pro y VIP) se facturan mensualmente. Puedes cancelar en cualquier momento.'
        },
        {
          title: '6. Datos y Precisión',
          text: 'Nos esforzamos por proporcionar datos precisos y actualizados, pero no garantizamos la exactitud de toda la información.'
        },
        {
          title: '7. Uso Aceptable',
          text: 'No debes usar el servicio para fines ilegales o no autorizados. Nos reservamos el derecho de suspender cuentas que violen estos términos.'
        },
        {
          title: '8. Cambios en los Términos',
          text: 'Podemos actualizar estos términos periódicamente. Te notificaremos de cualquier cambio significativo.'
        }
      ]
    },
    fr: {
      intro: "Bienvenue sur SharpBetAI. En utilisant nos services, vous acceptez les conditions suivantes.",
      sections: [
        {
          title: '1. Service',
          text: "SharpBetAI est une plateforme d'analyse de paris sportifs qui utilise l'intelligence artificielle pour suggérer des combinaisons de paris."
        },
        {
          title: '2. Éligibilité',
          text: "Pour utiliser SharpBetAI, vous devez avoir au moins 18 ans (ou l'âge légal minimum pour parier dans votre juridiction)."
        },
        {
          title: '3. Pas de Garantie de Profit',
          text: "Les analyses fournies par SharpBetAI sont basées sur des données statistiques. Nous ne garantissons pas de profits."
        },
        {
          title: '4. Responsabilité de l\'Utilisateur',
          text: "Vous êtes entièrement responsable de vos décisions de paris. SharpBetAI fournit des informations pour l'analyse."
        },
        {
          title: '5. Compte et Abonnement',
          text: "Les abonnements (Pro et VIP) sont facturés mensuellement. Vous pouvez annuler à tout moment."
        },
        {
          title: '6. Données et Précision',
          text: "Nous nous efforçons de fournir des données précises, mais nous ne garantissons pas l'exactitude de toutes les informations."
        },
        {
          title: '7. Utilisation Acceptable',
          text: "Vous ne devez pas utiliser le service à des fins illégales. Nous nous réservons le droit de suspendre les comptes en violation."
        },
        {
          title: '8. Modifications des Conditions',
          text: "Nous pouvons mettre à jour ces conditions périodiquement."
        }
      ]
    },
    de: {
      intro: 'Willkommen bei SharpBetAI. Durch die Nutzung unserer Dienste stimmst du den folgenden Bedingungen zu.',
      sections: [
        {
          title: '1. Dienst',
          text: 'SharpBetAI ist eine Sportwetten-Analyseplattform, die künstliche Intelligenz nutzt, um Wettvorschläge zu machen.'
        },
        {
          title: '2. Berechtigung',
          text: 'Um SharpBetAI zu nutzen, musst du mindestens 18 Jahre alt sein (oder das gesetzliche Mindestalter für Wetten in deiner Gerichtsbarkeit).'
        },
        {
          title: '3. Keine Gewinngarantie',
          text: 'Die von SharpBetAI bereitgestellten Analysen basieren auf statistischen Daten. Wir garantieren keine Gewinne.'
        },
        {
          title: '4. Benutzerverantwortung',
          text: 'Du bist vollständig für deine Wettentscheidungen verantwortlich.'
        },
        {
          title: '5. Konto und Abonnement',
          text: 'Abonnements (Pro und VIP) werden monatlich abgerechnet. Du kannst jederzeit kündigen.'
        },
        {
          title: '6. Daten und Genauigkeit',
          text: 'Wir bemühen uns, genaue Daten bereitzustellen, garantieren jedoch nicht die Richtigkeit aller Informationen.'
        },
        {
          title: '7. Akzeptable Nutzung',
          text: 'Du darfst den Dienst nicht für illegale Zwecke nutzen.'
        },
        {
          title: '8. Änderungen der Bedingungen',
          text: 'Wir können diese Bedingungen regelmäßig aktualisieren.'
        }
      ]
    }
  };

  const currentContent = content[language] || content.en;

  return (
    <div className="min-h-screen bg-background grain-overlay">
      {/* Header */}
      <nav className="border-b border-white/5 backdrop-blur-md bg-background/80 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link 
            to="/"
            className="flex items-center gap-2 text-white/70 hover:text-white transition-colors"
          >
            <ArrowLeft weight="bold" />
            <span>SharpBetAI</span>
          </Link>
          <LanguageSelector />
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-4xl font-heading font-black text-white mb-2">{t('termsTitle')}</h1>
        <p className="text-white/40 text-sm mb-8">{t('termsLastUpdate')}: 30 March 2026</p>

        <p className="text-white/70 mb-8 text-lg">{currentContent.intro}</p>

        <div className="space-y-8">
          {currentContent.sections.map((section, idx) => (
            <div key={idx} className="glass-surface p-6 rounded-sm">
              <h2 className="text-xl font-heading font-bold text-white mb-3">{section.title}</h2>
              <p className="text-white/70 leading-relaxed">{section.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link 
            to="/"
            className="inline-block px-8 py-3 bg-primary text-background font-bold rounded-full hover:bg-primary/90 transition-all"
          >
            {t('backToDashboard')}
          </Link>
        </div>
      </div>

      {/* Footer */}
      <footer className="border-t border-white/5 py-6 mt-12">
        <div className="max-w-4xl mx-auto px-6 text-center text-white/40 text-sm">
          <p>{t('footerCopyright')}</p>
        </div>
      </footer>
    </div>
  );
}
